<template>
  <div>
    <a-table :scroll="{ x: 1600 }" :pagination="pagination" :columns="columns" size="middle" :data-source="tableData" :loading="loading" row-key="id" @change="handleTableChange">
      <template slot="action" slot-scope="text, record">
        <a-dropdown placement="bottomCenter">
          <a-icon type="more" />
          <a-menu slot="overlay">
            <a-menu-item>
              <a v-tc="{ name: '编辑' }" class="ant-dropdown-link" @click="onEdit(record)"><a-icon type="edit" /> 编辑</a>
            </a-menu-item>
            <a-menu-item>
              <a v-tc="{ name: '复制' }" class="ant-dropdown-link" @click="onCopy(record)"><a-icon type="copy" /> 复制</a>
            </a-menu-item>
            <a-menu-item>
              <a v-tc="{ name: '关联用例' }" class="ant-dropdown-link" @click="onAddCase(record)"><a-icon type="plus" /> 关联用例</a>
            </a-menu-item>
            <a-menu-item>
              <a v-tc="{ name: '执行计划' }" class="ant-dropdown-link" @click="onExecPlan(record)"><a-icon type="caret-right" /> 执行计划</a>
            </a-menu-item>
            <a-menu-item>
              <a v-tc="{ name: '删除' }" class="ant-dropdown-link" @click="onDelete(record.id)"><a-icon type="delete" /> 删除</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </template>
      <template slot="testPlanName" slot-scope="text, record">
        <a-tooltip placement="top" :title="record.name">
          <a v-tc="{ name: '跳转详情' }" class="custom-link" :href="planLink(record)" target="_blank"> {{ record.name }} </a>
        </a-tooltip>
      </template>
      <template slot="status" slot-scope="text, record">
        <test-plan-status-edit :plan-id="record.id" :next-status="record.next_status" :status="record.status" @change="$emit('reload')" />
      </template>
      <template slot="progress" slot-scope="text, record">
        <a-progress :percent="record.progress" size="small" style="width: 130px" />
      </template>
      <template slot="casesProgress" slot-scope="text, record">
        <span style="padding-left: 30%">{{ record.finished_cases }}/{{ record.total_cases }}</span>
      </template>
      <template slot="type" slot-scope="text, record">
        {{ record.type ? testPlanTypes[record.type].label : '--' }}
      </template>
      <template slot="handlers" slot-scope="text, record">
        <user-profiles v-if="record.handlers" :value="record.handlers.map(item => item.id)" avatar />
      </template>
      <template slot="startTime" slot-scope="text, record">
        <test-plan-date-edit :data-source="record" item-name="start_time" @change="$emit('reload')" />
      </template>
      <template slot="endTime" slot-scope="text, record">
        <test-plan-date-edit :data-source="record" item-name="end_time" @change="$emit('reload')" />
      </template>
      <template slot="creator" slot-scope="text, record">
        <user-profiles v-if="record.creator" :value="[record.creator.id]" avatar />
      </template>
    </a-table>
    <plan-execute-modal ref="executeModalRef" @close="$emit('reload')" />
  </div>
</template>

<script>
import { testPlanTypes } from '@/utils/dictionary';
import { testPlanDelete } from '@/api/project/testPlan';

import TestPlanDateEdit from '@/pages/project/testplan/components/TestPlanDateEdit';
import PlanExecuteModal from '@/pages/project/testplan/components/PlanExecuteModal';
import TestPlanStatusEdit from '@/pages/project/testplan/components/TestPlanStatusEdit';

const basicColumns = [
  {
    align: 'center',
    width: 30,
    fixed: 'left',
    categorys: ['testplan'],
    scopedSlots: { customRender: 'action' }
  },
  {
    title: 'ID',
    dataIndex: 'key',
    key: 'key',
    width: 110,
    fixed: 'left',
    ellipsis: true
  },
  {
    title: '计划名称',
    width: 280,
    ellipsis: true,
    fixed: 'left',
    scopedSlots: { customRender: 'testPlanName' }
  },
  {
    title: '状态',
    width: 110,
    fixed: 'left',
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '测试进度',
    width: 150,
    fixed: 'left',
    scopedSlots: { customRender: 'progress' }
  },
  {
    title: '已完成/总数',
    width: 110,
    fixed: 'left',
    scopedSlots: { customRender: 'casesProgress' }
  },
  {
    title: '测试类型',
    width: 100,
    scopedSlots: { customRender: 'type' }
  },
  {
    title: '测试负责人',
    width: 160,
    scopedSlots: { customRender: 'handlers' }
  },
  {
    title: '开始时间',
    width: 150,
    scopedSlots: { customRender: 'startTime' }
  },
  {
    title: '结束时间',
    width: 150,
    scopedSlots: { customRender: 'endTime' }
  },
  {
    title: '创建人',
    width: 120,
    scopedSlots: { customRender: 'creator' }
  },
  {
    title: '创建时间',
    width: 180,
    dataIndex: 'created_time',
    key: 'created_time'
  },
  {
    title: '更新时间',
    width: 180,
    dataIndex: 'updated_time',
    key: 'updated_time'
  }
];

export default {
  name: 'TestPlanDataList',
  components: { TestPlanStatusEdit, TestPlanDateEdit, PlanExecuteModal },
  props: {
    category: {
      type: String,
      default: 'testplan'
    },
    loading: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: Array,
      default: () => []
    },
    pagination: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      basicColumns,
      testPlanTypes,
      projectId: parseInt(this.$route.params.project_id) || null
    };
  },
  computed: {
    planLink() {
      return record => {
        const route = this.$router.resolve({
          name: 'page:project:testplan:detail',
          query: { planId: record.id }
        });
        return route.href;
      };
    },
    columns() {
      return this.basicColumns.filter(item => Array.isArray(item.categorys) === false || item.categorys.includes(this.category));
    }
  },
  methods: {
    handleTableChange(pagination) {
      this.$emit('page-change', pagination);
    },
    onEdit(record) {
      this.$emit('edit', record);
    },
    onCopy(record) {
      this.$emit('copy', record);
    },
    onAddCase(record) {
      this.$emit('add-case', record);
    },
    onExecPlan(record) {
      this.$nextTick(() => {
        this.$refs.executeModalRef.onOpen(record.id);
      });
    },
    onDelete(id) {
      const self = this;
      this.$confirm({
        title: '确认',
        content: '确认要删除该测试计划吗',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        async onOk() {
          testPlanDelete({ project_id: self.projectId, test_plan_id: id }).then(() => {
            self.$message.success('删除成功');
            self.$emit('reload');
          });
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.custom-link {
  color: rgba(0, 0, 0, 0.65);
}

.custom-link:hover {
  color: #1890ff;
}
</style>
